export class Summary {
    ColumnHasSearch:boolean;
    SummaryId:string;
    SummaryName:string;
    SummaryClass:string;
    SystemSummaryName: string;
    TypeCode:string;
    TypeName:string;
    TotalRows:number;
    AvailablePages:number;
    PageSize:number;
    CurrentPage:number;
    SelectionType:string;
    CellSelectionType:string;
    ShowCheckmark:boolean;
    ShowFooter:boolean;
    ShowsFirstDetail:boolean;
    SortOptions:SummarySortOption[];
    IsDualView: boolean;
    IsScrollingTable: boolean;
    IsSortedAscending:boolean;
    Columns:SummaryColumn[];
    CardLayoutProperties:SummaryCardLayout[];
    Data;
    Functions: SummaryFunctions[];
    Actions:SummaryActions[];
    RowActions: SummaryActions[];
    HeaderText:string;
    FooterText:string;
    FooterHasButton: boolean;
    CardImageList: CardImage[];
    SummaryDisplay: string;
  }

  export class SummaryFunctions {
    ActionDisplay: string;
    ActionParameter: string;
    ActionSequence: number;
    ActionType: string;
  }

  export class SummaryColumn{
    AdditionalInfo:ValueSelection[];
    AdditionalParameter:string;
    ColumnFilterString: string;
    ColumnFilterArray:string[];
    ColumnIsSorted: boolean;
    ColumnSortIsAsc: boolean;
    FilterValueSelection: ValueSelection[];
    HasFooter: boolean;
    HasRemaining: boolean;
    IsID:boolean;
    IsFilterChanged:boolean;
    PropertyDisplay:string;
    PropertyId:string;
    PropertyIsHidden:boolean;
    PropertyName:string;
    PropertyOrder:number;
    RemainingValueColumn:string;
    ViewColumnFormat:string;
    ViewColumnType:string;
    WidthWeight:number;
    SortOrder:string;
    SortValue:string;
    CellsSelected:number;
  }

  export class SummaryCardLayout{
    CardProperty:string;
    PropertyFormat: string;
    PropertyName:string;
    PropertyColumnType:string;
    LayoutType:string;
    ColumnParameter:string;
  }

  export class SummarySortOption{
    SortField:string;
    SortOptionType:string;
    SortOrderIsAscending:boolean;
    SortOptionDisplay:string;
    IsSelected:boolean;
  }

  export class SummaryActions{
    ActionId:string;
    ActionName:string;
    ActionDisplay:string;
    ActionCommand:string;
    ActionOrder: number;
    DisplayOnGroup:string;
    ExactOneSelection: boolean;
    GroupId: string;
    IsDisabled: boolean;
    IsHidden: boolean;
    PromptMessage: string;
    PromptType: string;
    RequiresCellSelection:boolean;
    RequiresSelection: boolean;
    TriggersPrompt: boolean;
    TriggersValidation: boolean;
  }

  export class FilterOption{
    FilterField:string;
    FilterOptionType:string;
    FilterOptionDisplay:string;
    FilterOptionItems:FilterOptionItem[];
    SelectedFilterItem: string[];
    HasAdvancedFilter:boolean;
    AdvancedFilterValue: string;
    AdvancedFilterType: string;
    IsDropdownOpen:boolean;
    IsLoading: boolean;
  }

  export class FilterOptionItem{
    IsChecked:boolean;
    ItemValue:string;
    ItemDisplay:string;
  }

  export class AdvancedFilter {
    FilterField: string;
    FilterType: string;
    FilterValue: string;
    SelectedValues: string[];
  }

  export class CardImage {
    DocumentId: string;
    ImageId: string;
    Blob: any;
  }

  export class SubDetail {
    DocumentInstanceId: string;
    SummaryId: string;
  }

  export class PendingItemCount{
    IconType:string;
    IconText: number;
    IconColor:string;
    ViewID: number;
    ItemCount:string;
    ItemSequence:string;
  }
  
  export class ValueSelection {
    IsSelected:boolean;
    SelectionValue:string;
    SelectionDisplay:string;
  }

  export class SummaryPage {
    currentPage:number;
    availablePage:number;
  }

  export class StackCardBasic {
    StackNo:number;
    GroupId:string;
    Id:string;
    Type:string;
    ToggleNo:number;
    ShowCards:boolean;
  }